<script>
import ServidorDadosFuncionais from '@/components/shared/servidor/ServidorDadosFuncionais.vue'

export default {
  extends: ServidorDadosFuncionais,
}
</script>
